module.exports = __webpack_public_path__ + "img/Logomaker_LabDecabits.6c3d27d7.png";